<template>
    <svg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
        <g fill="#FFF" fill-rule="evenodd">
            <path d="M11.252 9.068a.501.501 0 0 0-.752.432v4.906a.5.5 0 0 0 .745.436l4.283-2.407a.498.498 0 0 0 .007-.867l-4.283-2.5z"/>
            <path d="M19.5 14.256A2.747 2.747 0 0 1 16.758 17H8.241A2.746 2.746 0 0 1 5.5 14.256V9.743A2.744 2.744 0 0 1 8.241 7h8.517A2.746 2.746 0 0 1 19.5 9.743v4.513zM12.5 0C5.883 0 .5 5.383.5 12c0 6.616 5.383 12 12 12s12-5.384 12-12c0-6.617-5.383-12-12-12z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconYoutube',
};
</script>